export enum FormsTabNames {
  TEMPLATES = 'templates',
  SUBMITTED = 'submitted',
  NEGATIVE_RESPONSES = 'negative_responses',
  AI_PHOTO_VALIDATION = 'ai-photo-validation',
  OVERDUE = 'overdue',
  DUE = 'due',
  UPCOMING = 'upcoming',
  DRAFT = 'draft',
  SCHEDULES = 'schedules',
}

export enum AdministrationTabNames {
  USER = 'users',
  GROUP = 'groups',
  ROLE = 'roles',
  CATEGORY = 'categories',
  API_KEY = 'api_key',
  SSO = 'sso'
}

export enum EntityItemsTabNames {
  ITEMS = 'items',
  FOLDERS = 'folders',
  TYPES = 'types',
}

export enum SensorsTabNames {
  SENSORS = 'sensors',
  GATEWAYS = 'gateways',
}

export enum AnalyticsTabNames {
  OVERVIEW = 'overview',
  NEGATIVE_RESPONSES = 'negative_responses',
  SCORES = 'scores',
  OVERDUE_INSPECTIONS = 'overdue_inspections',
  ISSUES = 'issues',
  SUMMARY = 'summary',
}

export enum SubscriptionTabNames {
  PLAN_DETAILS = 'plan_details',
  BILLING_DETAILS = 'billing_details',
  INVOICES = 'invoices',
  SUBSCRIPTION_LOG = 'subscription_log'
}

export enum UserProfileTabNames {
  GENERAL = 'general',
  CHANGE_PASSWORD = 'change_password',
  NOTIFICATIONS = 'notifications'
}

export enum UserEditTabNames {
  GENERAL = 'general',
  CHANGE_PASSWORD = 'change_password',
  NOTIFICATIONS = 'notifications'
}

export enum TrainingsTabNames {
  MANAGE = 'manage',
  TAKE = 'take',
  ASSIGNED = 'assigned',
  COMPLETED = 'completed',
}

export const queryTabName = 'tab';
